const PREFIX = '--'

export const useThemeCssColorVar = name => {
  const rootStyles = window.getComputedStyle(
    document.querySelector('#themeContainer')
  )

  return rootStyles.getPropertyValue(PREFIX + name)
}

export const setThemeCssColorVar = (name, color) => {
  document
    .getElementById('themeContainer')
    .style.setProperty(PREFIX + name, color)
}
